export const state = () => ({
  currentMonth: null,
  filters: [],
  isFirstScroll: true,
  isLeadersCalendar: false,
  isScrollToMonth: false,
  showCalendarFilters: false,
  showCalendarMenu: false,
  showFilterBar: true,
  showLeadersCalendar: false,
});

export const mutations = {
  setCurrentMonth(state, currentMonth) {
    state.currentMonth = currentMonth;
  },
  setFilters(state, filters) {
    state.filters = filters;
  },
  setIsFirstScroll(state, isFirstScroll) {
    state.isFirstScroll = isFirstScroll;
  },
  setIsLeadersCalendar(state, isLeadersCalendar) {
    state.isLeadersCalendar = isLeadersCalendar;
  },
  setIsScrollToMonth(state, isScrollToMonth) {
    state.isScrollToMonth = isScrollToMonth;
  },
  setShowCalendarFilters(state, showCalendarFilters) {
    state.showCalendarFilters = showCalendarFilters;
  },
  setShowCalendarMenu(state, showCalendarMenu) {
    state.showCalendarMenu = showCalendarMenu;
  },
  setShowFilterBar(state, showFilterBar) {
    state.showFilterBar = showFilterBar;
  },
  setShowLeadersCalendar(state, showLeadersCalendar) {
    state.showLeadersCalendar = showLeadersCalendar;
  },
};

export const actions = {
  updateCurrentMonth({ commit }, currentMonth) {
    commit('setCurrentMonth', currentMonth);
  },
  updateFilters({ commit }, filters) {
    commit('setFilters', filters);
  },
  updateIsFirstScroll({ commit }, isFirstScroll) {
    commit('setIsFirstScroll', isFirstScroll);
  },
  updateIsLeadersCalendar({ commit }, isLeadersCalendar) {
    commit('setIsLeadersCalendar', isLeadersCalendar);
  },
  updateIsScrollToMonth({ commit }, isScrollToMonth) {
    commit('setIsScrollToMonth', isScrollToMonth);
  },
  updateShowCalendarFilters({ commit }, showCalendarFilters) {
    commit('setShowCalendarFilters', showCalendarFilters);
  },
  updateShowCalendarMenu({ commit }, showCalendarMenu) {
    commit('setShowCalendarMenu', showCalendarMenu);
  },
  updateShowFilterBar({ commit }, showFilterBar) {
    commit('setShowFilterBar', showFilterBar);
  },
  updateShowLeadersCalendar({ commit }, showLeadersCalendar) {
    commit('setShowLeadersCalendar', showLeadersCalendar);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
